import { Component, OnInit } from '@angular/core';
import {FormGroup,FormControl, Validators} from '@angular/forms';
//Classe do angular utilizada para resgatar parametros enviado pela url do link
import { ActivatedRoute, Router } from '@angular/router';
import { Validacoes } from 'src/app/models/validacoes';

import { Acesso } from 'src/app/models/acesso';
import { AcessoService } from 'src/app/services/acesso.service';
import { HeaderService } from 'src/app/services/header.service';

import { Criptografar } from 'src/app/util/criptografar';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})

export class HomeComponent implements OnInit {

  frmAcesso!: FormGroup;
  public acesso: Acesso; //variavel para armazenar o modelo
  public liberarInscricao : boolean = false;

  campoCPF?: FormControl<any>;
  campoInscricao?:FormControl<any>;

  public isCandidatoInscrito : boolean = false; //Variavel para vaerificar se o candidato já está inscrito no concurso

  public isCampoCpfValido : boolean  = false;//variavel para monitorar se o campo cpf está validado.
  public tipoMsgCpf :string="";

  public isCampoInscricaoValido : boolean  = false;//variavel para monitorar se o campo inscricao está validado.
  public tipoMsgInscricao:string="";

  public descricaoPrazoConcurso : string="";
  public v_ExisteInscricao : any

  constructor(
    private router : Router,
    public objServiceApi : AcessoService,
    private objServiceHeader : HeaderService,
    protected utilService: UtilService
  ){
    this.acesso = new Acesso();
  }

  ngOnInit(): void {
    this.getPrazoConcurso();
    this.createForm(this.acesso);
  }

  createForm(acesso: Acesso) {
    this.frmAcesso = new FormGroup({
      cpf: new FormControl(acesso.cpf, [Validators.required,
                                        Validacoes.ValidaCpf]),
      inscricao: new FormControl(acesso.inscricao,null)
    })
  }

  getPrazoConcurso(){
    this.utilService.showLoading(true);
    this.objServiceHeader.getPrazoConcurso().subscribe((retorno) => {
     
      this.acesso.ind_prazoConcurso=retorno.situacao;

      switch(this.acesso.ind_prazoConcurso){
        case 'LIBERAR_COTISTA':
        case 'INICIADA':
          this.liberarInscricao=true;
          break;
        default:
          this.liberarInscricao=false;
      }

      this.utilService.showLoading(false);
    },
    error=> {
      this.utilService.showLoading(false);
      window.alert(error);
    })
  }

  btnOk() {
    window.location.href="https://emerj.tjrj.jus.br/";
  }

  onSubmit(){

    if (this.frmAcesso.invalid){
      return;
    }else{

        let v_inscricaoValida : any;

        this.acesso.cpf = this.frmAcesso.get('cpf')?.value;//Recupera o valor do campo CPF

        if(this.isCandidatoInscrito == false){
          this.utilService.showLoading(true);
          this.objServiceApi.existeInscricaoCandidato(this.acesso.cpf).subscribe((retorno) => {
            
            this.v_ExisteInscricao = retorno;

            if(this.v_ExisteInscricao == true){
              
              if(this.campoInscricao != null){
              this.campoInscricao.setValidators([Validators.required]);
              this.campoInscricao.updateValueAndValidity();
              }
              this.isCandidatoInscrito=true;
              this.acesso.candidatoInscrito = true;

            }else{

              switch(this.acesso.ind_prazoConcurso){

                case 'LIBERAR_COTISTA':
                case 'INICIADA':

                  this.isCandidatoInscrito=false;
                  this.acesso.candidatoInscrito = false;
                  let objCripto : Criptografar = new Criptografar();
                  let strAcesso = objCripto.encrypt(JSON.stringify(this.acesso));
                
                  this.utilService.showLoading(false);
                  this.router.navigate(['/fichainscricao'], { queryParams: { n: strAcesso } });
                  break;

                case 'NAO INICIADA':
                  this.descricaoPrazoConcurso='Período de inscrição ainda não foi iniciado, ao clicar em OK você será redirecionado para página da EMERJ.';
                  break;

                case 'ENCERRADA':
                  this.descricaoPrazoConcurso='Período de inscrição encerrado, ao clicar em OK você será redirecionado para página da EMERJ.';
                  break;

                case 'NAO_LIBERA':
                  this.descricaoPrazoConcurso='Período de inscrição não liberado, ao clicar em OK você será redirecionado para página da EMERJ.';
                  break;

                default:
              }
            }
            this.utilService.showLoading(false);
          },
          error=> {
            this.utilService.showLoading(false);
            error;
          })
        }
        else{

          if(this.campoInscricao != null && this.campoInscricao.valid){
            this.utilService.showLoading(true);
            this.acesso.inscricao = this.frmAcesso.get('inscricao')?.value;//Recupera o valor do campo inscricao
            this.objServiceApi.validarInscricaoCandidato(this.acesso)
            .subscribe((retorno) => {//validar se o numero de inscrição informado pertence ao cpf.
              v_inscricaoValida = retorno;
              if(v_inscricaoValida == false){
                this.tipoMsgInscricao="Nº de inscrição inválido."
              }else{

                let objCripto : Criptografar = new Criptografar();
                this.tipoMsgInscricao="";
                let strAcesso = objCripto.encrypt(JSON.stringify(this.acesso));
                this.utilService.showLoading(false);
                this.router.navigate(['/acompanhamento'], { queryParams: { n: strAcesso } });
              }
              this.utilService.showLoading(false);
            },
            error=> {
              this.utilService.showLoading(false);
              error;
            })
          }
        }
    }
  }

  soNumeros(event: KeyboardEvent) {

    const pattern = /[0-9]/g;
    const inputChar = String(parseInt(event.key));
    if (!pattern.test(inputChar)) {
        event.preventDefault();// invalid character, prevent input
    }
  }

  verificarCampoCpf(valor:string=''): string{

    var retorno = "INVALID";
    this.isCampoCpfValido = false;
    this.isCampoInscricaoValido = false;
    this.isCandidatoInscrito=false;
    this.acesso.inscricao="";//Limpando o valor da inscrição informada
    this.acesso.cpf=""//Limpando campo cpf
    this.acesso.candidatoInscrito=false;//Limpando o indicador se o candidato já está inscrito.

    this.descricaoPrazoConcurso="";
    
    this.campoCPF = <any>this.frmAcesso.get('cpf');

    if(this.campoCPF != null && this.campoCPF.invalid){

      if(this.campoCPF.errors?.['required']){
        this.tipoMsgCpf='CPF é obrigatório.';
      }else if(this.campoCPF.errors?.['cpfInvalido']){
        this.tipoMsgCpf='Digite um CPF válido.';
      }

    }else{
      this.isCampoCpfValido = true;
      this.tipoMsgCpf = 'VALID';
      retorno = 'VALID';
    }
    return retorno
  }

  verificarCampoInscricao(valor:string=''): string{

    var retorno = "INVALID";
    this.isCampoInscricaoValido = false;
    this.campoInscricao = <any>this.frmAcesso.get('inscricao');
    if(this.campoInscricao != null && this.campoInscricao.invalid){
      if(this.campoInscricao.errors?.['required']){
        this.tipoMsgInscricao='Nº de inscrição é obrigatório.';
      }
    }else{
      this.isCampoInscricaoValido = true;
      this.tipoMsgInscricao = 'VALID';
      retorno = 'VALID';
    }
    return retorno
  }

}

function subscribe(arg0: (retorno: any) => void, arg1: (error: any) => void) {
  throw new Error('Function not implemented.');
}
